import axios from 'axios';
import getCaseHistoryBaseUrl from './caseHistoryBaseUrl';
import {
    configureHttpHeaders,
    onSuccess,
    onError,
} from './apiHelpers';

const historyUrl = getCaseHistoryBaseUrl();

// This creates a controller used to cancel an http request if it is interrupted by the user
// If the user makes a selection that initiates a call, but the user then makes another selection
// before the call completes, the controller will cancel the initial call so you do not receive unanticipated results
// SEE GET CASE HISTORY FOR AN EXAMPLE
let controller;

export function getCaseHistory(caseNumber) {
    configureHttpHeaders(axios);

    if (controller !== undefined) {
        controller.abort();
    }
    // regenerate AbortController
    controller = new AbortController();
    return getHistory(`api/v1/eventmanager/event/details/${caseNumber}`, controller.signal);
}
export function getCaseEventLog(caseNumber) {
    configureHttpHeaders(axios);
    return getHistory(`api/v1/eventmanager/event/cases/${caseNumber}/auditlogs`);
    
}

function getHistory(url, source = '') {
    return axios.get(`${historyUrl}${url}`, {
        cancelToken: source.token,
    })
        .then(onSuccess)
        .catch(onError);
}

export default {
  getCaseHistory,
  getCaseEventLog,
};